<template>
  <svg class="gallery-mark" :class="{'gallery-mark--interactive': interactive}" viewBox="0 0 64 58" fill="currentColor" aria-hidden="true" focusable="false">
    <path v-if="interactive" class="gallery-mark-light" d="M26 54V28l12-6v32Z" />
    <path v-for="(path, index) in paths" :key="path" :class="{'gallery-mark-door': index === 1}" :d="path" fill="currentColor" stroke="none" fill-rule="evenodd"/>
  </svg>
</template>
<script>
import { galleryMarkPaths } from '../../utils/galleryIdentity';
export default { props: { interactive: Boolean }, data:()=>({paths:galleryMarkPaths}) };
</script>
<style scoped>
.gallery-mark{display:block;width:32px;height:29px;flex:none;}
.gallery-mark path{fill:currentColor;stroke:none;}
.gallery-mark--interactive .gallery-mark-door{transform-origin:39px 37px;transform:scaleX(var(--gallery-door-scale,1));transition:transform 240ms cubic-bezier(.22,1,.36,1);}
.gallery-mark .gallery-mark-light{fill:var(--gallery-entry-light,#b88c42);opacity:var(--gallery-light-opacity,0);transition:opacity 200ms ease;}
@media(prefers-reduced-motion:reduce){.gallery-mark--interactive .gallery-mark-door,.gallery-mark .gallery-mark-light{transition:none;}}
</style>
